import { useLayoutEffect, useState } from 'react';
import { LoaderCircle, Save } from 'lucide-react';

export function useDetectedModalLoading(content, enabled = true) {
  const [detected, setDetected] = useState(false);

  useLayoutEffect(() => {
    if (!enabled || !content || typeof MutationObserver === 'undefined') {
      setDetected(false);
      return undefined;
    }

    const update = () => {
      const candidates = content.querySelectorAll('.animate-spin, [aria-busy="true"], [data-modal-loading="true"]');
      const hasLoadingIndicator = Array.from(candidates).some((element) => !element.closest('[data-modal-loading-overlay], [data-send-feedback]'));
      setDetected((current) => current === hasLoadingIndicator ? current : hasLoadingIndicator);
    };
    update();
    const observer = new MutationObserver(update);
    observer.observe(content, { attributes: true, attributeFilter: ['class', 'aria-busy', 'data-modal-loading'], childList: true, subtree: true });
    return () => observer.disconnect();
  }, [content, enabled]);

  return detected;
}

export function ModalLoadingOverlay({ visible, label = 'Wird geladen', standalone = false, variant = 'loading', detail = '' }) {
  if (!visible) return null;
  return (
    <div data-modal-loading-overlay className={`absolute inset-0 z-[80] flex items-center justify-center rounded-[inherit] ${standalone ? 'bg-background' : 'bg-white/55 backdrop-blur-[2px]'}`} role="status" aria-live="polite" aria-label={label}>
      <div className={`flex flex-col items-center gap-4 px-6 py-5 ${standalone ? 'text-center' : 'rounded-2xl bg-white/95 shadow-lg'}`}>
        {variant === 'saving' ? (
          <div className="relative flex h-16 w-16 items-center justify-center" aria-hidden="true">
            <span className="absolute inset-0 rounded-full border-2 border-[#0071E3]/25 border-t-[#0071E3] animate-spin motion-reduce:animate-none" />
            <Save className="h-6 w-6 text-[#0071E3]" />
          </div>
        ) : <LoaderCircle className="h-9 w-9 animate-spin text-foreground" aria-hidden="true" />}
        <span className={variant === 'saving' ? 'text-base font-semibold text-foreground' : 'text-sm font-medium text-foreground'}>{label}</span>
        {detail && <p className="max-w-xs text-sm text-muted-foreground">{detail}</p>}
      </div>
    </div>
  );
}
